import React, { useEffect, useState, useContext, createContext } from 'react'
import { ArrowLeft, ArrowRight, Circle } from './icons'
import { useData } from '../DataProvider'
import useTranslation from '../../../shared/TranslationProvider'

const PanelNavContext = createContext({})

const useNavData = () => {
  return useContext(PanelNavContext)
}

const PanelNavProvider = ({ panelCount, children }) => {
  const [selectedPanel, setSelectedPanel] = useState(0)
  const { disableRotation, setDisableRotation } = useData()

  const nextPanel = () => {
    setDisableRotation(true)
    setSelectedPanel((index) => (index + 1) % panelCount)
  }
  const prevPanel = () => {
    setDisableRotation(true)
    setSelectedPanel((index) => (index - 1 + panelCount) % panelCount)
  }
  const clickPanel = (index) => {
    setDisableRotation(true)
    setSelectedPanel(index)
  }

  const data = {
    selectedPanel,
    clickPanel,
    panelCount,
    nextPanel,
    prevPanel,
  }

  useEffect(() => {
    if (disableRotation) return

    const interval = setInterval(() => {
      setSelectedPanel((index) => (index + 1) % panelCount)
    }, 20000)

    return () => clearInterval(interval)
  }, [selectedPanel, disableRotation, panelCount])

  return (
    <PanelNavContext.Provider value={data}>{children}</PanelNavContext.Provider>
  )
}

const PanelNav = () => {
  const { nextPanel, prevPanel, selectedPanel, clickPanel, panelCount } =
    useNavData()
  const { t } = useTranslation()
  return (
    <nav
      className="mt-16 flex items-center justify-center pb-4"
      aria-label={t('RightPanel.benefits')}
    >
      <button
        type="button"
        className="inline-flex cursor-pointer border-0 bg-transparent p-0"
        onClick={prevPanel}
        aria-label={t('RightPanel.carousel_previous')}
      >
        <ArrowLeft />
      </button>
      <span className="mx-8 space-x-10">
        {[...Array(panelCount).keys()].map((key) => (
          <button
            key={key}
            type="button"
            className="inline-flex cursor-pointer border-0 bg-transparent p-0"
            aria-label={t('RightPanel.carousel_slide_n_of_m', {
              index: key + 1,
              count: panelCount,
            })}
            aria-current={key === selectedPanel ? 'true' : undefined}
            onClick={() => clickPanel(key)}
          >
            <Circle active={key === selectedPanel} />
          </button>
        ))}
      </span>
      <button
        type="button"
        className="inline-flex cursor-pointer border-0 bg-transparent p-0"
        onClick={nextPanel}
        aria-label={t('RightPanel.carousel_next')}
      >
        <ArrowRight />
      </button>
    </nav>
  )
}

const PanelEnabled = ({ thisPanelNumber, children }) => {
  const selected = useNavData().selectedPanel === thisPanelNumber
  return selected && children
}

export default PanelNav
export { useNavData, PanelNavProvider, PanelEnabled }
